'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["slots", "slotProps", "className", "classes", "sx"];
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { ConversationRoot } from '@mui/x-chat-headless';
import { styled, createUseThemeProps } from "../internals/zero-styled/index.mjs";
import { useChatConversationUtilityClasses } from "./chatConversationClasses.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const useThemeProps = createUseThemeProps('MuiChatConversation');
const ChatConversationStyled = styled('div', {
  name: 'MuiChatConversation',
  slot: 'Root',
  overridesResolver: (_, styles) => styles.root
})(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: 0,
  minWidth: 0,
  overflow: 'hidden'
}));
const ChatConversation = /*#__PURE__*/React.forwardRef(function ChatConversation(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChatConversation'
  });
  const {
      slots,
      slotProps,
      className,
      classes: classesProp,
      sx
    } = props,
    other = _objectWithoutPropertiesLoose(props, _excluded);
  const classes = useChatConversationUtilityClasses(classesProp);
  return /*#__PURE__*/_jsx(ConversationRoot, _extends({
    ref: ref
  }, other, {
    slots: _extends({
      root: slots?.root ?? ChatConversationStyled
    }, slots),
    slotProps: _extends({}, slotProps, {
      root: _extends({
        className: clsx(classes.root, className),
        sx
      }, slotProps?.root)
    })
  }));
});
if (process.env.NODE_ENV !== "production") ChatConversation.displayName = "ChatConversation";
process.env.NODE_ENV !== "production" ? ChatConversation.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "pnpm proptypes"  |
  // ----------------------------------------------------------------------
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
  slotProps: PropTypes.object,
  slots: PropTypes.object,
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object])
} : void 0;
export { ChatConversation };